export const bfhfiles24 = [
    {
        id: 1,
        title: "Flyer",
        thumbnail: "https://static.igem.wiki/teams/5833/other/otherimages/bfh-flyer-european-meetup.avif",

        pdf: "https://static.igem.wiki/teams/5247/pdfs/bfh-flyer-european-meetup.pdf",
    }, {
        id: 2,
        title: "Guideline",
        thumbnail: "https://static.igem.wiki/teams/5833/other/otherimages/guideline24.avif",

        pdf: "https://static.igem.wiki/teams/5247/pdfs/bfh-meet-up-guideline.pdf",
    },
    {
        id: 3,
        title: "After Flyer",
        thumbnail: "https://static.igem.wiki/teams/5833/other/otherimages/bfh24-flyer-after.avif",

        pdf: "https://static.igem.wiki/teams/5247/pdfs/postbfh-brosch-re-compressed.pdf",
    },
    {
        id: 4,
        title: "Sticker Album",
        thumbnail: "https://static.igem.wiki/teams/5247/pdfs/album24.avif",

        pdf: "https://static.igem.wiki/teams/5247/pdfs/bfh-stickeralbum.pdf",
    },
    {
        id: 5,
        title: "Judging Form",
        thumbnail: "https://static.igem.wiki/teams/5833/other/otherimages/judging24.avif",

        pdf: "https://static.igem.wiki/teams/5247/pdfs/judging-form-bfh.pdf",
    },
]